<template>
  <div class="login">
    <div class="main">
      <div class="header">
        <div class="company">
          <div class="sys-name">{{ sysName }}</div>
          <div class="sys-subtitle">
            <div class="left icon">
              <img src="../assets/images/左-装饰.png" />
            </div>
            <div class="subtitle">{{ subname }}</div>
            <div class="right icon">
              <img src="../assets/images/右-装饰.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="body">
        <div class="submit-wrap">
          <el-form class="form" :model="form" ref="form" label-position="top" :rules="rules">
            <el-form-item prop="username">
              <el-input v-model="form.username">
                <div slot="prefix" class="input-icon">
                  <img class="prefix-icon" src="../assets/images/用户.png" />
                </div>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" show-password>
                <div slot="prefix" class="input-icon">
                  <img class="prefix-icon" src="../assets/images/密码.png" />
                </div>
              </el-input>
            </el-form-item>
            <el-form-item class="code" prop="code">
              <el-input v-model="form.code" @keyup.enter.native="onSubmit('form')">
                <div slot="prefix" class="input-icon">
                  <img class="prefix-icon" src="../assets/images/验证码_FS.png" />
                </div>
                <div slot="suffix" class="suffix-icon">
                  <img class="ver-code" @click="getVerCode" :src="verCode" />
                </div>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" @click="onSubmit('form')">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiData } from "../api/index";
import { encrypt } from "@/utils/crypto";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      verCode: "",
      form: {
        username: "",
        password: "",
        code: "",
        uuid: "",
        unitid: this.$route.params.unit.id,
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 8,
            max: 18,
            message: "长度在 8到 18 个字符",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      loginMethod: 0,
      sysName: "",
      subname: "",
    };
  },
  created() {
    this.getVerCode();
  },
  mounted() {
    const { unit } = this.$route.params;
    this.sysName = unit.sysname;
    this.subname = unit.subname;
    document.getElementsByTagName("html")[0].style.fontSize =
      (document.body.clientWidth / 1920) * 16 + "px";
    window.onresize = () => {
      document.getElementsByTagName("html")[0].style.fontSize =
        (document.body.clientWidth / 1920) * 16 + "px";
    };
  },
  methods: {
    ...mapMutations("home", ["changeCardTypes"]),
    /**
     * 获取验证码
     */
    async getVerCode() {
      const res = await apiData.getVerCode();
      if (res.status === 200) {
        this.form.uuid = res.data.uuid;
        this.verCode = `data:image/png;base64,${res.data.img}`;
      }
    },
    /**
     * 登录
     */
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const obj = JSON.parse(JSON.stringify(this.form));
          console.log("obj", JSON.stringify(obj));
          if (obj.password.length < 19) {
            obj.password = encrypt(obj.password);
          }
          console.log("obj", JSON.stringify(obj));
          const { status, msg, data } = await apiData.checkLogin(obj);
          if (status === 200) {
            this.$message({
              message: msg,
              type: "success",
            });
            const { company, unit } = this.$route.params;
            console.log("unit", unit);

            // axios.defaults.headers.common.token = resultData
            localStorage.clear();
            sessionStorage.clear();
            sessionStorage.setItem("token", JSON.stringify(data));
            // localStorage.setItem('token', JSON.stringify(resultData))
            localStorage.setItem(
              company,
              JSON.stringify({
                unit,
                token: data,
              }),
            );
            this.changeCardTypes(unit);
            this.$router.push({
              name: "Home",
              params: { company },
            });
          } else {
            this.getVerCode();
            this.$message.error(msg);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.input-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0 1vw;

  .prefix-icon {
    width: 1vw;
    height: 1vw;
  }
}

.code {
  /deep/ .el-input__suffix {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /deep/ .el-input__suffix-inner {
    line-height: normal;
  }

  /deep/ .el-input__inner {
    padding-right: 8vw;
  }

  .suffix-icon {
    height: 1.8vw;

    .ver-code {
      width: 100%;
      height: 100%;
    }
  }
}

.login {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: url("../assets/images/登录背景_FS.png") 0 center no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  .main {
    width: 600px;
    //width: 40vw;
    //height: 60vh;
    display: flex;
    flex-direction: column;

    .header {
      flex: 1;
      display: flex;
      flex-direction: column;

      .company {
        .sys-name {
          text-align: center;
          font-weight: 520;
          font-size: 2vw;
          color: #ffffff;
          text-shadow: 0px 2px 4px rgba(1, 37, 89, 0.6);
          margin-bottom: 1.2vw;
        }

        .sys-subtitle {
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            flex: 1;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .subtitle {
            flex: 1.2;
            text-align: center;
            font-weight: 400;
            font-size: 1.2vw;
            color: #ffffff;
          }
        }

        margin-bottom: 1.2vw;
      }
    }

    .body {
      flex: 4;
      width: 100%;
      height: auto;
      background: url("../assets/images/登录框.png") 0 center no-repeat;
      background-size: 100% 100%;

      .submit-wrap {
        .form {
          width: 100%;
        }

        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5vw 7vw;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        overflow: hidden;

        /deep/ .el-input__inner:focus {
          border-color: #97d6ff;
          /* 例如: #409EFF */
        }

        /deep/ .el-input__inner {
          height: 48px;
          background-color: #0b315a;
          border-color: #587992;
          padding-left: 60px;
          color: #fff;
        }

        .login-btn {
          border: none;
          width: 100%;
          height: 48px;
          background: linear-gradient(43deg, #1a94f3 0%, #6cbfff 100%);
          border-radius: 6px;
          text-align: center;
          color: #ffffff;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
